<template>
  <div class="grid grid-cols-1 md:grid-cols-2 bg-white font-sans font-size-reset" style="min-height: 625px;">
    <div class="bg-gradient-to-r from-cal-blue via-cal-light-blue to-cal-green flex items-center justify-center order-2 md:order-1">
      <plan-details
          :coverage-type="user.subscription.plan.coverage_state === 1 ? 'state' : 'county'"
          :coverage-limit="user.subscription.plan.coverage_limit"
          :plan-name="user.subscription.plan.name"
          :plan-price="'$' + user.subscription.plan.base_price"
          :total-price="'$' + user.subscription.payment_total"
          :users-count="user.subscription.plan.users_count"
          :is-free-trial="!user.subscription.activated"
          :is-completed="true"
      >
      </plan-details>
    </div>
    <div class="bg-white p-4 flex flex-col justify-center items-center order-1 md:order-2">
      <div class="text-center space-y-4 mx-8">
        <h1 class="m-0 text-cal-blue text-4xl font-bold">Welcome to Construct-A-Lead!</h1>
        <h3 class="m-0 text-cal-light-blue text-2xl">We can't wait to help you grow your leads and business</h3>
        <div class="">
          <router-link
              :to="{ name: 'projects' }"
              class="inline-block bg-cal-gold px-6 py-2 text-cal-blue uppercase border-0 font-bold rounded-sm shadow-md no-underline"
          >
            Go to Dashboard
          </router-link>
        </div>
      </div>
      <div v-if="!user.subscription.activated" class="mt-16 text-center text-cal-blue">
        <p class="mb-4">You cannot download projects during the trial.</p>
        <p class="mb-6"><strong>For a more complete view, schedule a demo.</strong></p>
        <a href="https://www.constructalead.com/schedule-a-demo/" target="_blank" class="bg-cal-gold px-6 py-2 text-cal-blue uppercase border-0 font-bold rounded-sm shadow-sm no-underline">Schedule a demo</a>
      </div>
    </div>
  </div>
</template>
<script>
import auth from '../../services/Client/Auth';
import PlanDetails from "./SignUp/PlanDetails";
import Format from "../../mixins/Format";

export default {
  mixins: [Format],
  components: {PlanDetails},
  data() {
    return {
      user: auth.user
    }
  },
}
</script>
